<template>
  <div>
    <el-row class=" mab_20" type="flex" :gutter="20">
      <el-col :span="24">
        <div class="filter-inline-panel cle">
          <el-form :inline="true" size="mini" :model="filterForm" class="filter-panel">
			
          </el-form>
          <div class="list-opinion fr">
            <el-button type="primary" v-if="hasBtn('btn_add')" size="mini" @click="emailEdit()">新建</el-button>
          </div>
        </div>
        <el-table :data="list" border size="mini">
          <el-table-column prop="name" align="center" label="字典名称"></el-table-column>
          <el-table-column prop="code" align="center" label="字典编码"></el-table-column>
          <el-table-column label="操作" width="300" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="emailEdit(scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="emailDelete(scope.row)">删除</el-button>
              <el-button size="mini" type="primary" @click="zidianleib(scope.row)">字典项目列表</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-row class="tree-content" type="flex" :gutter="20">
      <el-col :span="24" class="page-pagination">
        <el-pagination style="float:right;" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
      </el-col>
    </el-row>
    <el-row class="tree-content" type="flex" :gutter="20">
      <el-dialog title="编辑" width="700px" :visible="editFormVisible" @close="editFormVisible = false">
        <el-form :model="editForm" :inline="true" size="mini" label-width="100px" :rules="editFormRules" ref="editForm">
          <el-form-item label="字典名称" prop="name">
            <el-input v-model="editForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="字典编码:" prop="code">
            <el-input v-model="editForm.code" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" size="mini" @click.native="editSubmit('editForm')">提交</el-button>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>
<script>
export default {
	data() {
		return {
			editFormVisible: false,
			editForm: {
				code: '',
				name: '',
			},
			list: [],
			editFormRules: {
				code: [{
					required: true,
					message: '请输入code',
					trigger: 'blur'
				}],
				name: [{
					required: true,
					message: '请输入名称',
					trigger: 'blur'
				}],
			},
			filterForm: {
				keyword:'',
			},
			pages: {
				page: 1,
				count: 100,
				perpage: 50,
			},
		}
	},
	// 初始事件
	mounted: function () {
		this.init();
	},
	// 事件
	methods: {
		// 初始化
		init() {
			var this_ = this;
			var url = "dictionaryList";
			var datas = {
				page: this_.pages.page,
				num: this_.pages.perpage,
				keyword:this_.filterForm.keyword,
			};
			this_.$post(url, datas,true).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		// 编辑
		emailEdit(e) {
			if (e) {
				this.editForm = e;
			}else{
				this.editForm = {
					code: '',
					name: '',
				}
			}
			this.editFormVisible = true;
		},
		// 保存
		editSubmit(editForm) {
			var this_ = this;
			this_.$refs[editForm].validate((valid) => {
				if (valid) {
					var url = "addDictionary";
					var datas = {
						name: this_.editForm.name,
						code: this_.editForm.code,
					}
					var tishi = '添加成功';
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
						url = "editDictionary";
						tishi = '修改成功';
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		// 删除
		emailDelete(e) {
			var this_ = this;
			var url = "deleteDictionary";
			var datas = {
				id: e.id
			};
			this_.$confirm('确认删除吗?', '提示', {
				//type: 'warning'
			}).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success('删除成功');
					this_.init();
				})
			}).catch(() => {
			});
		},
		// 转跳字典项目列表
		zidianleib(e) {
			var id = e.id;
			this.$router.push({
				path: 'data_parameter_info',
				query: {
					id: id
				}
			});
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-panel {
	display: inline-block;
	width: 80%;
	vertical-align: top;
}
.page-pagination {
	padding: 20px 10px;
}
.filter-inline-panel{
	margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/data/parameter.vue